import { Component, EventEmitter, Input, Output } from '@angular/core';
import { heightAnimation } from '@lib/animations';
import { Me } from '@lib/services/me.service';
import { SearchService } from '@lib/services/search.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
  animations: [heightAnimation]
})
export class AppMenuComponent {

    @Input() currentItem: any;
    @Input() currentMainItem: any;

    @Output() onImpersonate = new EventEmitter<Me>();

    constructor(public me: Me,
                private searchService: SearchService) { }
    
    get searchState () {return this.searchService.state}

    isExternalLink (link: string | string[]): boolean {
        if(Array.isArray(link))
            return false;
        else
            return link && link.match(/^https?:\/\//)?.length > 0;
    }
}
